<template>
  <d2-container>
    <div class="toolbar">
      <el-button
        class="filter-item"
        type="primary"
        size="mini"
        icon="el-icon-circle-plus"
        @click="openDialog()"
      >添加分类</el-button>
    </div>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      :loading="listLoading"
      :data="categoryList"
    >
      <el-table-column align="center" label="ID" prop="id" width="80" />
      <el-table-column align="center" label="名称" prop="name" min-width="140" />
      <el-table-column label="图标" align="center" width="140">
        <template slot-scope="scope">
          <img v-if="scope.row.icon" :src="scope.row.icon" class="thumb" />
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="排序" prop="sort" width="100" />
      <el-table-column align="center" label="创建时间" prop="createTime" min-width="170" />
      <el-table-column align="center" label="更新时间" prop="updateTime" min-width="170" />
      <el-table-column align="center" label="操作" fixed="right" width="200">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="openDialog(scope.row)"
            style="margin-top: 6px;"
          >编辑</el-button>
          <el-button
            size="small"
            type="danger"
            @click="handleRemove(scope.row)"
            style="margin-top: 6px;"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="520px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="resetForm"
    >
      <el-form :model="form" :rules="rules" ref="formRef" label-width="90px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入分类名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :step="1" step-strictly></el-input-number>
        </el-form-item>
        <el-form-item label="图标">
          <upload-img
            v-model="form.icon"
            :imgSize="1"
            :show-tips="false"
            :width="120"
          ></upload-img>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>

<script>
import uploadImg from '@/components/uploadImage/index.vue'
import {
  addPromptCategory,
  getPromptCategoryList,
  removePromptCategory,
  updatePromptCategory
} from '@/api/common/prompt'

export default {
  name: 'promptCategory',
  components: { uploadImg },
  data () {
    return {
      tableKey: 0,
      listLoading: false,
      categoryList: [],
      dialogVisible: false,
      dialogTitle: '新增分类',
      form: {
        id: null,
        name: '',
        icon: '',
        sort: 0
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        sort: [{ type: 'number', message: '排序必须为数字', trigger: 'change' }]
      }
    }
  },
  created () {
    this.loadCategories()
  },
  methods: {
    loadCategories () {
      this.listLoading = true
      getPromptCategoryList()
        .then(res => {
          this.categoryList = res || []
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    openDialog (row) {
      this.dialogTitle = row ? '编辑分类' : '新增分类'
      this.dialogVisible = true
      this.form = row
        ? {
          id: row.id,
          name: row.name,
          icon: row.icon,
          sort: row.sort
        }
        : {
          id: null,
          name: '',
          icon: '',
          sort: 0
        }
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
    },
    submitForm () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        const payload = {
          name: this.form.name,
          icon: this.form.icon,
          sort: this.form.sort
        }
        const request = this.form.id
          ? updatePromptCategory(this.form.id, payload)
          : addPromptCategory(payload)
        request.then(() => {
          this.$message({
            message: this.form.id ? '更新成功' : '新增成功',
            type: 'success',
            center: true
          })
          this.dialogVisible = false
          this.loadCategories()
        })
      })
    },
    handleRemove (row) {
      this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => removePromptCategory(row.id))
        .then(() => {
          this.$message({
            message: '删除成功',
            type: 'success',
            center: true
          })
          this.loadCategories()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    resetForm () {
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields()
      }
      this.form = {
        id: null,
        name: '',
        icon: '',
        sort: 0
      }
    }
  }
}
</script>

<style scoped>
.toolbar {
  margin-bottom: 12px;
}
.thumb {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #ebeef5;
}
</style>
